// extracted by mini-css-extract-plugin
export default {"wrapper":"OrdersListItemRenderer_wrapper__fVS6j"};